// ⚠️ NOTA: adminService temporariamente simplificado
// Funcionalidades de admin podem ser gerenciadas via painelweb no futuro

import { apiService } from './apiService';

export const adminService = {
  async getSettings() {
    console.warn('adminService.getSettings não implementado');
    return {};
  },

  async updateSetting(key, value) {
    console.warn('adminService.updateSetting não implementado');
    return null;
  },

  async getDashboardStats() {
    try {
      // Placeholder - poderia retornar stats via API
      return {
        totalContent: 0,
        totalUsers: 0,
        totalViews: 0
      };
    } catch (error) {
      console.error('Error getting dashboard stats:', error);
      throw error;
    }
  }
};
